import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Dropdown,
  Input
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardSaveServiceOrderUX = (props: any) => {
    return(
      <div
        style={{ height: "80vh" }}>
        <div
          style={{padding: "10px" }}>
          
          <div
            id="CardSaveServiceOrderUX-div-23">
            
            <Form
              id="CardSaveServiceOrderUX-Form-24">
              <FormGroup
                id="CardSaveServiceOrderUX-FormGroup-25"
                style={{alignItems: "center", display: "flex"}}>
                <FormField
                  id="CardSaveServiceOrderUX-FormField-26"
                  width={3}>
                  <div
                    id="CardSaveServiceOrderUX-div-29">
                    
                    <label
                      id="CardSaveServiceOrderUX-label-32"
                      style={{ fontWeight: "bold", fontSize: "16px" }}>
                      รายการค่าบริการ
                    </label>
                  </div>
                </FormField>
                <FormField
                  id="CardSaveServiceOrderUX-FormField-27"
                  style={{ marginRight: "20px" }}
                  width={5}>
                  <div
                    id="CardSaveServiceOrderUX-div-30"
                    style={{alignItems: "center", display: "flex"}}>
                    
                    <div
                      id="CardSaveServiceOrderUX-div-33"
                      style={{ minWidth: "max-content", marginRight: "10px" }}>
                      หมายเลขรับบริการ
                    </div>
                    <Dropdown
                      clearable={true}
                      fluid={true}
                      id="CardSaveServiceOrderUX-Dropdown-34"
                      onChange={props.onChangeEncounter}
                      options={props.encounterListOption}
                      selection={true}
                      style={{ color: "var(--primary-theme-color)", fontWeight: "bold" }}
                      value={props.selectedEncounter?.id}>
                    </Dropdown>
                  </div>
                </FormField>
                <FormField
                  id="CardSaveServiceOrderUX-FormField-28"
                  width={10}>
                  <div
                    id="CardSaveServiceOrderUX-div-31"
                    style={{alignItems: "center", display: "flex", padding: "15px 20px", backgroundColor: "rgba(255, 229, 229, 1)",}}>
                    
                    <div
                      id="CardSaveServiceOrderUX-div-35"
                      style={{ marginRight: "10px", minWidth: "max-content" }}>
                      วันที่รับบริการ
                    </div>
                    <div
                      id="CardSaveServiceOrderUX-div-36"
                      style={{ marginRight: "30px", minWidth: "max-content" }}>
                      {props.selectedEncounter?.created || "-"}
                    </div>
                    <div
                      id="CardSaveServiceOrderUX-div-37"
                      style={{ marginRight: "10px", minWidth: "max-content" }}>
                      ผู้ให้บริการ
                    </div>
                    <div
                      id="CardSaveServiceOrderUX-div-38"
                      style={{ marginRight: "10px", minWidth: "max-content" }}>
                      {props.selectedEncounter?.doctor_name || "-"}
                    </div>
                  </div>
                </FormField>
              </FormGroup>
              <FormGroup
                id="CardSaveServiceOrderUX-FormGroup-39"
                style={{display: "flex", alignItems: "flex-end"}}>
                <FormField
                  id="CardSaveServiceOrderUX-FormField-40"
                  style={{ flex: "1" }}>
                </FormField>
                <FormField>
                  <div>
                    {props.buttonOpenURL}
                  </div>
                </FormField>
                <FormField
                  id="CardSaveServiceOrderUX-FormField-61">
                  <div
                    id="CardSaveServiceOrderUX-div-62">
                    {props.buttonCopy}
                  </div>
                </FormField>
                <FormField
                  id="CardSaveServiceOrderUX-FormField-41"
                  width={6}>
                  <label
                    id="CardSaveServiceOrderUX-label-42">
                    ชื่อรายการค่าบริการ
                  </label>
                  <Input
                    icon="search"
                    id="CardSaveServiceOrderUX-Input-43"
                    onChange={props.onChangeSearchText}
                    placeholder="ค้นหาชื่อรายการค่าบริการ"
                    value={props.searchText}>
                  </Input>
                  <div
                    id="CardSaveServiceOrderUX-div-58"
                    style={{ display: props.showSearchResult ? "block" : "none", border: "solid #cccccc 1px", position: "absolute", zIndex: 100, minHeight: "100px" , backgroundColor: "white", maxHeight: "300px", overflow: "auto", width: "37%" }}>
                    {props.searchResult}
                  </div>
                </FormField>
                <FormField
                  id="CardSaveServiceOrderUX-FormField-44">
                  <div
                    id="CardSaveServiceOrderUX-div-45">
                    {props.buttonSearch}
                  </div>
                </FormField>
              </FormGroup>
              <FormGroup
                id="CardSaveServiceOrderUX-FormGroup-46">
                <div
                  id="CardSaveServiceOrderUX-div-47"
                  style={{ width: "100%", padding: "0px 5px" }}>
                  
                  <Table
                    className="--rt-tbody-overflow-y-hidden"
                    data={props.serviceOrderPreviewData}
                    defaultPageSize="10"
                    headers="No,รหัสบริการ,ชื่อบริการ,จำนวนรายการ,ราคาต่อหน่วย,ราคารวม,วันที่ค่าใช้จ่าย,ลบ"
                    id="CardSaveServiceOrderUX-Table-48"
                    keys="no,service_code,name,quantity,price_unit,price_total,perform_datetime,delete"
                    minRows="10"
                    pageSize="10"
                    showPagination={false}
                    style={{height: "50vh"}}
                    widths="60,100,auto,130,130,130,110,60">
                  </Table>
                </div>
              </FormGroup>
              <FormGroup
                id="CardSaveServiceOrderUX-FormGroup-59">
                <div
                  id="CardSaveServiceOrderUX-div-60"
                  style={{ width: "100%" }}>
                  {props.serviceFeeItem}
                </div>
              </FormGroup>
              <FormGroup
                className="--override-disabled --grey"
                id="CardSaveServiceOrderUX-FormGroup-49"
                style={{alignItems: "center", display: "flex"}}>
                <FormField
                  id="CardSaveServiceOrderUX-FormField-50"
                  style={{ marginLeft: "50px" }}>
                  <label
                    id="CardSaveServiceOrderUX-label-53">
                    ยอดรวมทั้งหมด
                  </label>
                </FormField>
                <FormField
                  id="CardSaveServiceOrderUX-FormField-51"
                  width={8}>
                </FormField>
                <FormField
                  id="CardSaveServiceOrderUX-FormField-52"
                  width={2}>
                  <Input
                    disabled={true}
                    id="CardSaveServiceOrderUX-Input-54"
                    value={props.sumTotal || 0.00}>
                  </Input>
                </FormField>
              </FormGroup>
              <FormGroup
                id="CardSaveServiceOrderUX-FormGroup-55"
                style={{ display: "flex", justifyContent: "flex-end" }}>
                <div
                  id="CardSaveServiceOrderUX-div-56"
                  style={{ margin: "0px 10px" }}>
                  {}
                  <div
                    id="CardSaveServiceOrderUX-div-57">
                    {props.buttonSave}
                  </div>
                </div>
              </FormGroup>
            </Form>
          </div>
        </div>
      </div>
    )
}


export default CardSaveServiceOrderUX

export const screenPropsDefault = {"language":"TH","showSearchResult":false}

/* Date Time : Mon Sep 14 2026 09:42:34 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ height: \"80vh\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 22,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\" }"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-div-23"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "Form",
      "parent": 23,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-Form-24"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "FormGroup",
      "parent": 24,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-FormGroup-25"
        },
        "style": {
          "type": "code",
          "value": "{alignItems: \"center\", display: \"flex\"}"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "FormField",
      "parent": 25,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-FormField-26"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "FormField",
      "parent": 25,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-FormField-27"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"20px\" }"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "FormField",
      "parent": 25,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-FormField-28"
        },
        "width": {
          "type": "code",
          "value": "10"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "div",
      "parent": 26,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-div-29"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "div",
      "parent": 27,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-div-30"
        },
        "style": {
          "type": "code",
          "value": "{alignItems: \"center\", display: \"flex\"}"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "div",
      "parent": 28,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-div-31"
        },
        "style": {
          "type": "code",
          "value": "{alignItems: \"center\", display: \"flex\", padding: \"15px 20px\", backgroundColor: \"rgba(255, 229, 229, 1)\",}"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 32,
      "name": "label",
      "parent": 29,
      "props": {
        "children": {
          "type": "value",
          "value": "รายการค่าบริการ"
        },
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-label-32"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"16px\" }"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": null,
      "id": 33,
      "name": "div",
      "parent": 30,
      "props": {
        "children": {
          "type": "value",
          "value": "หมายเลขรับบริการ"
        },
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-div-33"
        },
        "style": {
          "type": "code",
          "value": "{ minWidth: \"max-content\", marginRight: \"10px\" }"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "Dropdown",
      "parent": 30,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-Dropdown-34"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeEncounter"
        },
        "options": {
          "type": "code",
          "value": "props.encounterListOption"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"var(--primary-theme-color)\", fontWeight: \"bold\" }"
        },
        "value": {
          "type": "code",
          "value": "props.selectedEncounter?.id"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": null,
      "id": 35,
      "name": "div",
      "parent": 31,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่รับบริการ"
        },
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-div-35"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\", minWidth: \"max-content\" }"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": null,
      "id": 36,
      "name": "div",
      "parent": 31,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectedEncounter?.created || \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-div-36"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"30px\", minWidth: \"max-content\" }"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": null,
      "id": 37,
      "name": "div",
      "parent": 31,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ให้บริการ"
        },
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-div-37"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\", minWidth: \"max-content\" }"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "div",
      "parent": 31,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectedEncounter?.doctor_name || \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-div-38"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\", minWidth: \"max-content\" }"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 39,
      "name": "FormGroup",
      "parent": 24,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-FormGroup-39"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"flex-end\"}"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 40,
      "name": "FormField",
      "parent": 39,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-FormField-40"
        },
        "style": {
          "type": "code",
          "value": "{ flex: \"1\" }"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 41,
      "name": "FormField",
      "parent": 39,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-FormField-41"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "label",
      "parent": 41,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อรายการค่าบริการ"
        },
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-label-42"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "Input",
      "parent": 41,
      "props": {
        "icon": {
          "type": "value",
          "value": "search"
        },
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-Input-43"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeSearchText"
        },
        "placeholder": {
          "type": "value",
          "value": "ค้นหาชื่อรายการค่าบริการ"
        },
        "value": {
          "type": "code",
          "value": "props.searchText"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "FormField",
      "parent": 39,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-FormField-44"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": null,
      "id": 45,
      "name": "div",
      "parent": 44,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-div-45"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 46,
      "name": "FormGroup",
      "parent": 24,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-FormGroup-46"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": null,
      "id": 47,
      "name": "div",
      "parent": 46,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-div-47"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", padding: \"0px 5px\" }"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 48,
      "name": "Table",
      "parent": 47,
      "props": {
        "NoDataComponent": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "data": {
          "type": "code",
          "value": "props.serviceOrderPreviewData"
        },
        "defaultPageSize": {
          "type": "value",
          "value": "10"
        },
        "expanded": {
          "type": "value",
          "value": ""
        },
        "expanderDefaults": {
          "type": "value",
          "value": ""
        },
        "headers": {
          "type": "value",
          "value": "No,รหัสบริการ,ชื่อบริการ,จำนวนรายการ,ราคาต่อหน่วย,ราคารวม,วันที่ค่าใช้จ่าย,ลบ"
        },
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-Table-48"
        },
        "keys": {
          "type": "value",
          "value": "no,service_code,name,quantity,price_unit,price_total,perform_datetime,delete"
        },
        "minRows": {
          "type": "value",
          "value": "10"
        },
        "name": {
          "type": "value",
          "value": ""
        },
        "onExpandedChange": {
          "type": "value",
          "value": ""
        },
        "pageSize": {
          "type": "value",
          "value": "10"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"50vh\"}"
        },
        "widths": {
          "type": "value",
          "value": "60,100,auto,130,130,130,110,60"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 49,
      "name": "FormGroup",
      "parent": 24,
      "props": {
        "className": {
          "type": "value",
          "value": "--override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-FormGroup-49"
        },
        "style": {
          "type": "code",
          "value": "{alignItems: \"center\", display: \"flex\"}"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 50,
      "name": "FormField",
      "parent": 49,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-FormField-50"
        },
        "style": {
          "type": "code",
          "value": "{ marginLeft: \"50px\" }"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 51,
      "name": "FormField",
      "parent": 49,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-FormField-51"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 52,
      "name": "FormField",
      "parent": 49,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-FormField-52"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "label",
      "parent": 50,
      "props": {
        "children": {
          "type": "value",
          "value": "ยอดรวมทั้งหมด"
        },
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-label-53"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "Input",
      "parent": 52,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-Input-54"
        },
        "readOnly": {
          "type": "code",
          "value": ""
        },
        "readonly": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.sumTotal || 0.00"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "FormGroup",
      "parent": 24,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-FormGroup-55"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"flex-end\" }"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": null,
      "id": 56,
      "name": "div",
      "parent": 55,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-div-56"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 10px\" }"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": null,
      "id": 57,
      "name": "div",
      "parent": 56,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSave"
        },
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-div-57"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": null,
      "id": 58,
      "name": "div",
      "parent": 41,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchResult"
        },
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-div-58"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.showSearchResult ? \"block\" : \"none\", border: \"solid #cccccc 1px\", position: \"absolute\", zIndex: 100, minHeight: \"100px\" , backgroundColor: \"white\", maxHeight: \"300px\", overflow: \"auto\", width: \"37%\" }"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "FormGroup",
      "parent": 24,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-FormGroup-59"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "widths": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": null,
      "id": 60,
      "name": "div",
      "parent": 59,
      "props": {
        "children": {
          "type": "code",
          "value": "props.serviceFeeItem"
        },
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-div-60"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 61,
      "name": "FormField",
      "parent": 39,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-FormField-61"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": null,
      "id": 62,
      "name": "div",
      "parent": 61,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonCopy"
        },
        "id": {
          "type": "value",
          "value": "CardSaveServiceOrderUX-div-62"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 63,
      "name": "FormField",
      "parent": 39,
      "props": {
      },
      "seq": 41,
      "void": false
    },
    {
      "from": null,
      "id": 64,
      "name": "div",
      "parent": 63,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonOpenURL"
        }
      },
      "seq": 64,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardSaveServiceOrderUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "TH",
    "showSearchResult": false
  },
  "width": 80
}

*********************************************************************************** */
